import { render, staticRenderFns } from "./ThirteenthSection.vue?vue&type=template&id=e01261d6&scoped=true&"
import script from "./ThirteenthSection.vue?vue&type=script&lang=js&"
export * from "./ThirteenthSection.vue?vue&type=script&lang=js&"
import style0 from "./ThirteenthSection.vue?vue&type=style&index=0&id=e01261d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01261d6",
  null
  
)

export default component.exports